import type { CartLineInput } from '@ifixit/shopify-storefront-client';
import type { CartLineItem } from '../types';

/**
 * Names the add to cart that put a line in the cart. Shopify copies line
 * attributes onto the order's line item as properties, so sales can be
 * credited to the button or list without GA4. Shopify hides properties whose
 * key starts with an underscore from customers at checkout.
 * cart-fields.fragment.graphql reads it back by this key.
 */
const ADDED_FROM_ATTRIBUTE_KEY = '_added_from';

export function toCartLineInput(line: CartLineItem, addedFrom = line.addedFrom): CartLineInput {
   return {
      merchandiseId: line.shopifyVariantId,
      quantity: line.quantity,
      sellingPlanId: line.sellingPlanId,
      attributes: addedFrom ? [{ key: ADDED_FROM_ATTRIBUTE_KEY, value: addedFrom }] : undefined,
   };
}
